<template>
  <v-col cols="12" v-if="permisoVista('sensores', 'r')" :class="{ 'embedded-col': embedded }">
    <v-card class="sensor-config-card" :class="{ 'sensor-config-card--embedded': embedded }" elevation="0">
      <div v-if="!embedded" class="sensor-config-card__glow"></div>

      <div v-if="!embedded" class="sensor-config-card__header">
        <div>
          <div class="sensor-config-card__eyebrow">Configuracion</div>
          <h2 class="sensor-config-card__title">Sensores</h2>
          <p class="sensor-config-card__subtitle">
            Administra el catalogo de sensores disponible para configuracion.
          </p>
        </div>

        <v-btn
          v-if="permisoVista('sensores', 'c')"
          color="primary"
          dark
          class="sensor-config-card__cta"
          @click="openCreateExternal"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>
          Nuevo Sensor
        </v-btn>
      </div>

      <v-dialog v-model="dialog" persistent max-width="520px">
        <v-card class="sensor-dialog">
            <v-card-title class="sensor-dialog__title">
              {{ formTitle }}
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedItem.codigo"
                      label="Codigo"
                      prepend-inner-icon="mdi-pound"
                      outlined
                      dense
                      autofocus
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedItem.nombre"
                      label="Nombre del Sensor"
                      prepend-inner-icon="mdi-radar"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedItem.descripcion"
                      label="Descripcion"
                      prepend-inner-icon="mdi-text-box-outline"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-alert
                  v-if="errores.length > 0"
                  type="error"
                  text
                  dense
                  class="mb-0"
                >
                  <div
                    v-for="(error, index) in errores"
                    :key="'error-sensor-' + index"
                  >
                    {{ error }}
                  </div>
                </v-alert>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                :disabled="saving"
                :loading="saving"
                @click="save"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      <div class="sensor-config-card__toolbar">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar sensor o codigo"
          single-line
          hide-details
          outlined
          dense
          class="sensor-config-card__search"
        ></v-text-field>

        <v-btn text color="primary" @click="initialize">
          <v-icon left small>mdi-refresh</v-icon>
          Refrescar
        </v-btn>
      </div>

      <v-dialog v-model="dialogDependencias" max-width="520px">
        <v-card v-if="dependItem" class="depend-dialog">
          <v-card-title class="depend-dialog__title">
            <v-icon color="warning" left>mdi-alert-outline</v-icon>
            No se puede desactivar el sensor
          </v-card-title>
          <v-card-text>
            <p class="mb-3">
              El sensor <strong>{{ dependItem.codigo }}</strong> no puede desactivarse porque tiene
              <strong>{{ dependItem.variablesAsignadas }} variable(s) asignada(s)</strong>.
            </p>
            <div class="subtitle-2 mb-1">Variables asignadas:</div>
            <ul class="depend-dialog__list">
              <li v-for="(v, i) in (dependItem.variablesAsignadasLista || [])" :key="i">{{ v }}</li>
            </ul>
            <v-alert dense text type="warning" class="mb-0 mt-3">
              Para desactivar este sensor, primero desasocia sus variables.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogDependencias = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAssignment" persistent max-width="680px">
        <v-card class="sensor-dialog">
          <v-card-title class="sensor-dialog__title">
            Gestionar variables del sensor
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="sensor-name-cell">
                    <div class="sensor-name-cell__icon">
                      <v-icon color="primary" small>mdi-radar</v-icon>
                    </div>
                    <div>
                      <div class="sensor-name-cell__title">
                        {{ assignmentTarget ? assignmentTarget.nombre : "Sensor" }}
                      </div>
                      <div class="sensor-name-cell__caption">
                        Codigo: {{ assignmentTarget ? assignmentTarget.codigo : "N/A" }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="assignmentForm.idVariable"
                    :items="getAvailableVariables()"
                    :item-text="formatVariableLabel"
                    item-value="idVariable"
                    item-disabled="disabled"
                    label="Variable"
                    prepend-inner-icon="mdi-variable"
                    outlined
                    dense
                    :loading="loadingVariables || loadingSensorVariables"
                    :disabled="savingAssignment || loadingVariables || loadingSensorVariables"
                    :error-messages="assignmentErrors.idVariable"
                    @focus="assignmentErrors.idVariable = null"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ formatVariableLabel(data.item) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.usageLabel || "Disponible" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-combobox
                    ref="aliasCombobox"
                    v-model="assignmentForm.aliases"
                    :search-input.sync="aliasSearch"
                    label="Alias / EP"
                    hint="Escribe el alias y presiona Enter para agregarlo"
                    persistent-hint
                    prepend-inner-icon="mdi-tag-outline"
                    outlined
                    dense
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    hide-selected
                    :disabled="savingAssignment"
                    :error-messages="assignmentErrors.aliases"
                    @focus="assignmentErrors.aliases = null"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    v-if="assignmentForm.idSensorVariable"
                    text
                    color="blue darken-1"
                    class="mr-2"
                    :disabled="savingAssignment"
                    @click="resetAssignmentForm"
                  >
                    Cancelar edición
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="savingAssignment"
                    :loading="savingAssignment"
                    @click="saveAssignment"
                  >
                    {{ assignmentForm.idSensorVariable ? "Actualizar variable" : "Agregar variable" }}
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="assignmentErrors.general">
                  <span class="red--text">{{ assignmentErrors.general }}</span>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="assignmentHeaders"
                    :items="currentSensorAssignments"
                    :loading="loadingSensorVariables || loadingAliasSensorVariables"
                    dense
                    no-data-text="No hay variables asignadas para este sensor."
                  >
                    <template v-slot:[`item.variableLabel`]="{ item }">
                      <v-chip small color="primary" text-color="white">
                        {{ formatVariableLabel(item) }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.aliasLabel`]="{ item }">
                      <div v-if="item.aliases && item.aliases.length" class="sensor-aliases">
                        <v-chip
                          v-for="alias in item.aliases"
                          :key="`${item.idSensorVariable}-${alias}`"
                          small
                          outlined
                          color="primary"
                          class="mr-1 mb-1"
                        >
                          {{ alias }}
                        </v-chip>
                      </div>
                      <span v-else class="text--secondary">Sin alias</span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            small
                            color="blue darken-1"
                            @click="editAssignment(item)"
                          >
                            <v-icon small>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span class="white--text">Editar variable</span>
                      </v-tooltip>
                      <v-tooltip bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            small
                            color="orange darken-2"
                            :loading="deletingAssignmentId === item.idSensorVariable"
                            @click="deleteAssignment(item)"
                          >
                            <v-icon small>mdi-link-off</v-icon>
                          </v-btn>
                        </template>
                        <span class="white--text">Quitar variable</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAssignmentDialog">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        class="sensor-config-table"
        :headers="headers"
        :items="sensores"
        :search="search"
        :loading="loading"
        loading-text="Cargando... Espere, Por Favor."
      >
        <template v-slot:[`item.nombre`]="{ item }">
          <div class="sensor-name-cell">
            <div class="sensor-name-cell__icon">
              <v-icon color="primary" small>mdi-radar</v-icon>
            </div>
            <div>
              <div class="sensor-name-cell__title">{{ item.nombre }}</div>
              <div class="sensor-name-cell__caption">
                Codigo: {{ item.codigo }}
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.descripcion`]="{ item }">
          <span class="text--secondary">{{ item.descripcion || "N/A" }}</span>
        </template>

        <template v-slot:[`item.variableLabel`]="{ item }">
          <div v-if="item.variableItems && item.variableItems.length" class="sensor-aliases">
            <v-chip
              v-for="variable in item.variableItems"
              :key="`${item.idSensor}-${variable.idSensorVariable}`"
              small
              color="primary"
              text-color="white"
              class="mr-1 mb-1"
            >
              {{ formatVariableLabel(variable) }}
            </v-chip>
          </div>
          <v-chip
            v-else
            small
            color="grey lighten-1"
            outlined
          >
            Sin asignar
          </v-chip>
        </template>

        <template v-slot:[`item.aliasLabel`]="{ item }">
          <div v-if="item.aliases && item.aliases.length" class="sensor-aliases">
            <v-chip
              v-for="alias in item.aliases"
              :key="`${item.idSensor}-${alias}`"
              small
              outlined
              color="primary"
              class="mr-1 mb-1"
            >
              {{ alias }}
            </v-chip>
          </div>
          <span v-else class="text--secondary">Sin alias</span>
        </template>

        <template v-slot:[`item.estadoAsignacion`]="{ item }">
          <div class="asoc-cell">
            <v-chip
              small
              outlined
              :color="item.variablesAsignadas > 0 ? 'success' : 'warning'"
            >
              {{ item.variablesAsignadas > 0 ? `${item.variablesAsignadas} variable(s)` : "Disponible" }}
            </v-chip>
            <a v-if="item.variablesAsignadas > 0" class="asoc-cell__link" @click="verAsociaciones(item)">Ver detalle</a>
          </div>
        </template>

        <template v-slot:[`item.condicion`]="{ item }">
          <v-switch
            :key="'sen-sw-' + item.idSensor + '-' + estadoNonce"
            :input-value="item.condicion !== false"
            :loading="togglingId === item.idSensor"
            :disabled="togglingId === item.idSensor || !(permisoVista('sensores','u') || permisoVista('sensores','d'))"
            color="success"
            dense
            hide-details
            inset
            class="estado-switch"
            :label="item.condicion === false ? 'Inactivo' : 'Activo'"
            @change="toggleEstado(item)"
          ></v-switch>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip
            v-if="permisoVista('sensores', 'u') || permisoVista('sensores', 'c')"
            bottom
            color="black"
            class="white--text"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                small
                color="primary"
                class="mr-1"
                @click="openAssignmentDialog(item)"
              >
                Asignar variable
              </v-btn>
            </template>
            <span class="white--text">
              {{ item.idSensorVariable ? "Editar variable asignada" : "Asignar variable" }}
            </span>
          </v-tooltip>

          <v-tooltip
            v-if="permisoVista('sensores', 'u')"
            bottom
            color="black"
            class="white--text"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                small
                color="blue darken-1"
                @click="editItem(item)"
              >
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span class="white--text">Editar</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <div class="sensor-empty-state">
            <v-icon color="blue-grey lighten-1" large>
              mdi-radar-off
            </v-icon>
            <div class="sensor-empty-state__title">No hay sensores registrados</div>
            <div class="sensor-empty-state__subtitle">
              Crea un sensor nuevo para comenzar.
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar
      v-model="snackbar.show"
      top
      centered
      :timeout="3200"
      :color="snackbar.color"
      class="sensor-snackbar"
    >
      <div class="sensor-snackbar__content">
        <v-icon dark left>{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
    </v-snackbar>
  </v-col>
</template>

<script>
import axios from "axios";

export default {
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      loadingVariables: false,
      loadingSensorVariables: false,
      loadingAliasSensorVariables: false,
      saving: false,
      savingAssignment: false,
      deletingAssignmentId: null,
      dialog: false,
      dialogAssignment: false,
      dialogDependencias: false,
      dependItem: null,
      togglingId: null,
      estadoNonce: 0,
      search: "",
      sensores: [],
      variables: [],
      sensorVariables: [],
      aliasSensorVariables: [],
      errores: [],
      assignmentErrors: {
        idVariable: null,
        aliases: null,
        general: null,
      },
      editedIndex: -1,
      assignmentTarget: null,
      headers: [
        {
          text: "Sensor",
          value: "nombre",
          align: "left",
          sortable: true,
        },
        {
          text: "Descripcion",
          value: "descripcion",
          align: "left",
          sortable: true,
        },
        {
          text: "Variable",
          value: "variableLabel",
          align: "left",
          sortable: true,
        },
        {
          text: "Alias / EP",
          value: "aliasLabel",
          align: "left",
          sortable: true,
        },
        {
          text: "Estado",
          value: "estadoAsignacion",
          align: "left",
          sortable: true,
        },
        {
          text: "Condición",
          value: "condicion",
          align: "center",
          sortable: true,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "22%",
        },
      ],
      assignmentHeaders: [
        {
          text: "Variable",
          value: "variableLabel",
          sortable: true,
          align: "left",
        },
        {
          text: "Alias / EP",
          value: "aliasLabel",
          sortable: false,
          align: "left",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "14%",
        },
      ],
      editedItem: {
        idSensor: null,
        codigo: "",
        nombre: "",
        descripcion: "",
      },
      defaultItem: {
        idSensor: null,
        codigo: "",
        nombre: "",
        descripcion: "",
      },
      assignmentForm: {
        idSensorVariable: null,
        idVariable: null,
        aliases: [],
        fechaInicio: null,
      },
      aliasSearch: "",
      snackbar: {
        show: false,
        text: "",
        color: "success",
        icon: "mdi-check-circle-outline",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Sensor" : "Editar Sensor";
    },
    currentSensorAssignments() {
      if (!this.assignmentTarget || !this.assignmentTarget.idSensor) return [];
      return this.getSensorVariablesForSensor(this.assignmentTarget.idSensor).map((item) => ({
        ...item,
        aliases: this.getAliasesForSensorVariable(item.idSensorVariable)
          .map((alias) => this.normalizeAliasValue(alias.clavePayload))
          .filter(Boolean),
        aliasLabel: this.getAliasesForSensorVariable(item.idSensorVariable)
          .map((alias) => this.normalizeAliasValue(alias.clavePayload))
          .filter(Boolean)
          .join(", "),
      }));
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    requestSensorVariables(method, suffix = "", data = null, params = null) {
      return axios({
        method,
        url: `/SensorVariables${suffix}`,
        data,
        params,
      });
    },
    requestAliasSensorVariables(method, suffix = "", data = null, params = null) {
      return axios({
        method,
        url: `/AliasSensorVariables${suffix}`,
        data,
        params,
      });
    },
    getCurrentIsoDateTime() {
      const now = new Date();
      const offsetMs = now.getTimezoneOffset() * 60000;
      return new Date(now.getTime() - offsetMs).toISOString().slice(0, 19);
    },
    parseDateValue(value) {
      if (!value) return null;
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    normalizeStartDateForBackend(value) {
      const nowString = this.getCurrentIsoDateTime();
      const nowDate = this.parseDateValue(nowString);
      const currentDate = this.parseDateValue(value);
      if (!currentDate) return nowString;
      if (nowDate && currentDate > nowDate) return nowString;
      return value;
    },
    formatVariableLabel(item) {
      if (!item) return "";
      const codigo = item.codigo || item.variableCodigo || "";
      const nombre = item.nombre || item.variableNombre || "";
      return [codigo, nombre].filter(Boolean).join(" - ") || "Variable";
    },
    normalizeVariable(item = {}) {
      return {
        ...item,
        idVariable: item.idVariable || item.IdVariable || item.id || item.Id || null,
        codigo: item.codigo || item.Codigo || "",
        nombre: item.nombre || item.Nombre || "",
        descripcion: item.descripcion || item.Descripcion || "",
        condicion: typeof item.condicion === "boolean" ? item.condicion : item.Condicion,
      };
    },
    normalizeSensorVariable(item = {}) {
      return {
        ...item,
        idSensorVariable:
          item.idSensorVariable || item.IdSensorVariable || item.id || item.Id || null,
        idSensor: item.idSensor || item.IdSensor || null,
        sensorCodigo: item.sensorCodigo || item.SensorCodigo || "",
        sensorNombre: item.sensorNombre || item.SensorNombre || "",
        idVariable: item.idVariable || item.IdVariable || null,
        variableCodigo: item.variableCodigo || item.VariableCodigo || "",
        variableNombre: item.variableNombre || item.VariableNombre || "",
        condicion: typeof item.condicion === "boolean" ? item.condicion : item.Condicion,
        fechaInicio: item.fechaInicio || item.FechaInicio || null,
        fechaFin: item.fechaFin || item.FechaFin || null,
      };
    },
    normalizeAliasSensorVariable(item = {}) {
      return {
        ...item,
        idAliasSensorVariable:
          item.idAliasSensorVariable || item.IdAliasSensorVariable || item.id || item.Id || null,
        idSensorVariable: item.idSensorVariable || item.IdSensorVariable || null,
        idSensor: item.idSensor || item.IdSensor || null,
        idVariable: item.idVariable || item.IdVariable || null,
        clavePayload: item.clavePayload || item.ClavePayload || "",
        condicion: typeof item.condicion === "boolean" ? item.condicion : item.Condicion,
        fechaInicio: item.fechaInicio || item.FechaInicio || null,
        fechaFin: item.fechaFin || item.FechaFin || null,
      };
    },
    normalizeAliasValue(alias) {
      return `${alias == null ? "" : alias}`.trim();
    },
    isActiveRecord(item) {
      return !!item && item.condicion !== false;
    },
    initialize() {
      this.setLoading(true);
      Promise.all([
        axios.get("/CatSensores?incluirInactivos=true"),
        this.loadVariables(),
        this.loadSensorVariables(),
        this.loadAliasSensorVariables(),
      ])
        .then(([response]) => {
          const items = Array.isArray(response.data) ? response.data : [];
          this.sensores = items.map(this.normalizeItem);
          this.applyAssignmentsToSensores();
          this.setLoading(false);
          this.$emit("count-changed", this.sensores.length);
        })
        .catch((error) => {
          this.setLoading(false);
          this.handleError(error, "No se pudieron cargar los sensores.");
        });
    },
    setLoading(value) {
      this.loading = value;
      this.$emit("loading-changed", value);
    },
    openCreate() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.errores = [];
    },
    openCreateExternal() {
      this.openCreate();
      this.dialog = true;
    },
    normalizeItem(item = {}) {
      return {
        ...item,
        idSensor:
          item.idSensor ||
          item.IdSensor ||
          item.id ||
          item.Id ||
          null,
        codigo: item.codigo || item.Codigo || "",
        nombre: item.nombre || item.Nombre || "",
        descripcion: item.descripcion || item.Descripcion || "",
        condicion: typeof item.condicion === "boolean" ? item.condicion : item.Condicion,
        variablesAsignadas: item.variablesAsignadas ?? item.VariablesAsignadas ?? 0,
        variablesAsignadasLista: item.variablesAsignadasLista || item.VariablesAsignadasLista || [],
        idSensorVariable: item.idSensorVariable || null,
        idVariable: item.idVariable || null,
        variableLabel: item.variableLabel || "Sin asignar",
        aliasLabel: item.aliasLabel || "Sin alias",
        aliases: Array.isArray(item.aliases) ? item.aliases : [],
        estadoAsignacion: item.estadoAsignacion || "Disponible",
      };
    },
    loadVariables() {
      this.loadingVariables = true;
      return axios
        .get("/Variables")
        .then((response) => {
          const items = Array.isArray(response.data) ? response.data : [];
          this.variables = items
            .map(this.normalizeVariable)
            .filter((item) => this.isActiveRecord(item));
        })
        .catch((error) => {
          this.variables = [];
          console.log(error);
        })
        .finally(() => {
          this.loadingVariables = false;
        });
    },
    loadSensorVariables(idSensor = null) {
      this.loadingSensorVariables = true;
      const suffix = idSensor != null ? `/PorSensor/${idSensor}` : "";
      return this.requestSensorVariables("get", suffix)
        .then((response) => {
          const items = Array.isArray(response.data) ? response.data : [];
          const normalizedItems = items
            .map(this.normalizeSensorVariable)
            .filter((item) => this.isActiveRecord(item));
          this.sensorVariables = idSensor != null
            ? [
              ...this.sensorVariables.filter((item) => item.idSensor != idSensor),
              ...normalizedItems,
            ]
            : normalizedItems;
        })
        .catch((error) => {
          if (idSensor == null) {
            this.sensorVariables = [];
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingSensorVariables = false;
        });
    },
    loadAliasSensorVariables({ idSensor = null, idSensorVariable = null } = {}) {
      this.loadingAliasSensorVariables = true;
      let suffix = "";
      if (idSensorVariable != null) suffix = `/PorSensorVariable/${idSensorVariable}`;
      else if (idSensor != null) suffix = `/PorSensor/${idSensor}`;
      return this.requestAliasSensorVariables("get", suffix)
        .then((response) => {
          const items = Array.isArray(response.data) ? response.data : [];
          const normalizedItems = items
            .map(this.normalizeAliasSensorVariable)
            .filter((item) => this.isActiveRecord(item));
          if (idSensorVariable != null) {
            this.aliasSensorVariables = [
              ...this.aliasSensorVariables.filter((item) => item.idSensorVariable != idSensorVariable),
              ...normalizedItems,
            ];
          } else if (idSensor != null) {
            this.aliasSensorVariables = [
              ...this.aliasSensorVariables.filter((item) => item.idSensor != idSensor),
              ...normalizedItems,
            ];
          } else {
            this.aliasSensorVariables = normalizedItems;
          }
        })
        .catch((error) => {
          if (idSensor == null && idSensorVariable == null) {
            this.aliasSensorVariables = [];
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingAliasSensorVariables = false;
        });
    },
    getSensorVariableForSensor(idSensor) {
      return this.sensorVariables.find((item) => item.idSensor == idSensor) || null;
    },
    getSensorVariablesForSensor(idSensor) {
      return this.sensorVariables.filter((item) => item.idSensor == idSensor);
    },
    getAliasesForSensorVariable(idSensorVariable) {
      return this.aliasSensorVariables.filter((item) => item.idSensorVariable == idSensorVariable);
    },
    applyAssignmentsToSensores() {
      this.sensores = this.sensores.map((sensor) => {
        const sensorVariables = this.getSensorVariablesForSensor(sensor.idSensor);
        const aliasValues = sensorVariables
          .flatMap((sensorVariable) => this.getAliasesForSensorVariable(sensorVariable.idSensorVariable))
          .map((item) => this.normalizeAliasValue(item.clavePayload))
          .filter(Boolean);

        return {
          ...sensor,
          idSensorVariable: sensorVariables.length ? sensorVariables[0].idSensorVariable : null,
          idVariable: sensorVariables.length ? sensorVariables[0].idVariable : null,
          variableItems: sensorVariables,
          variableLabel: sensorVariables.length
            ? sensorVariables.map((sensorVariable) => this.formatVariableLabel({
              codigo: sensorVariable.variableCodigo,
              nombre: sensorVariable.variableNombre,
            })).join(", ")
            : "Sin asignar",
          aliasLabel: aliasValues.length ? aliasValues.join(", ") : "Sin alias",
          aliases: aliasValues,
          estadoAsignacion: sensorVariables.length ? "En uso" : "Disponible",
        };
      });
    },
    resetAssignmentForm() {
      this.assignmentForm = {
        idSensorVariable: null,
        idVariable: null,
        aliases: [],
        fechaInicio: null,
      };
      this.assignmentErrors = {
        idVariable: null,
        aliases: null,
        general: null,
      };
      this.aliasSearch = "";
    },
    getVariableUsage(idVariable, currentSensorVariableId = null) {
      return this.sensorVariables.find((item) => {
        if (item.idVariable != idVariable) return false;
        if (currentSensorVariableId != null && item.idSensorVariable == currentSensorVariableId) return false;
        return true;
      }) || null;
    },
    getAvailableVariables() {
      const currentSensorVariableId = this.assignmentForm.idSensorVariable || null;
      return this.variables.map((item) => {
        const usage = this.getVariableUsage(item.idVariable, currentSensorVariableId);
        return {
          ...item,
          disabled: !!usage,
          usageLabel: usage
            ? `En uso por ${usage.sensorNombre || usage.sensorCodigo || "otro sensor"}`
            : "Disponible",
        };
      });
    },
    getAliasUsage(alias, currentSensorVariableId = null) {
      const normalizedAlias = this.normalizeAliasValue(alias).toUpperCase();
      return this.aliasSensorVariables.find((item) => {
        const currentAlias = this.normalizeAliasValue(item.clavePayload).toUpperCase();
        if (!normalizedAlias || currentAlias !== normalizedAlias) return false;
        if (currentSensorVariableId != null && item.idSensorVariable == currentSensorVariableId) return false;
        return true;
      }) || null;
    },
    openAssignmentDialog(item) {
      this.assignmentTarget = Object.assign({}, item);
      this.resetAssignmentForm();
      this.dialogAssignment = true;
      Promise.all([
        this.loadSensorVariables(item.idSensor),
        this.loadAliasSensorVariables({ idSensor: item.idSensor }),
      ]).then(() => {
        this.applyAssignmentsToSensores();
      });
    },
    editAssignment(item) {
      this.assignmentForm = {
        idSensorVariable: item.idSensorVariable,
        idVariable: item.idVariable,
        aliases: Array.isArray(item.aliases) ? [...item.aliases] : [],
        fechaInicio: item.fechaInicio || null,
      };
      this.assignmentErrors = {
        idVariable: null,
        aliases: null,
        general: null,
      };
      this.aliasSearch = "";
    },
    closeAssignmentDialog() {
      this.dialogAssignment = false;
      this.assignmentTarget = null;
      this.resetAssignmentForm();
    },
    validateAssignment() {
      this.assignmentErrors.idVariable = null;
      this.assignmentErrors.aliases = null;
      this.assignmentErrors.general = null;

      if (!this.assignmentForm.idVariable) {
        this.assignmentErrors.idVariable = "Seleccione una variable.";
      }
      const aliases = Array.isArray(this.assignmentForm.aliases)
        ? this.assignmentForm.aliases.map(this.normalizeAliasValue).filter(Boolean)
        : [];
      if (!aliases.length) {
        this.assignmentErrors.aliases = "Capture al menos un alias o EP.";
      }
      const localDuplicates = aliases.filter((alias, index) => aliases.findIndex((item) => item.toUpperCase() === alias.toUpperCase()) !== index);
      if (localDuplicates.length) {
        this.assignmentErrors.aliases = "No repita alias dentro del mismo sensor.";
      }
      const globalDuplicate = aliases.find((alias) =>
        this.getAliasUsage(alias, this.assignmentForm.idSensorVariable || null)
      );
      if (globalDuplicate) {
        this.assignmentErrors.aliases = `El alias ${globalDuplicate} ya está en uso en otro sensor o máquina.`;
      }
      if (!this.assignmentErrors.aliases && aliases.some((alias) => alias.length > 255)) {
        this.assignmentErrors.aliases = "Cada alias no puede exceder 255 caracteres.";
      }

      const usage = this.getVariableUsage(
        this.assignmentForm.idVariable,
        this.assignmentForm.idSensorVariable || null
      );
      if (usage) {
        this.assignmentErrors.idVariable = `La variable ya esta en uso por ${usage.sensorNombre || usage.sensorCodigo || "otro sensor"}.`;
      }

      return !Object.values(this.assignmentErrors).some((value) => value != null);
    },
    validate() {
      this.errores = [];
      if (!this.editedItem.codigo) {
        this.errores.push("El codigo es obligatorio.");
      }
      if (this.editedItem.codigo && this.editedItem.codigo.length > 50) {
        this.errores.push("El codigo no puede exceder 50 caracteres.");
      }
      if (!this.editedItem.nombre) {
        this.errores.push("El nombre del sensor es obligatorio.");
      }
      if (this.editedItem.nombre && this.editedItem.nombre.length > 120) {
        this.errores.push("El nombre del sensor no puede exceder 120 caracteres.");
      }
      if (this.editedItem.descripcion && this.editedItem.descripcion.length > 255) {
        this.errores.push("La descripcion no puede exceder 255 caracteres.");
      }
      return this.errores.length === 0;
    },
    save() {
      if (!this.validate()) return;

      this.saving = true;
      const payload = {
        codigo: this.editedItem.codigo,
        nombre: this.editedItem.nombre,
        descripcion: this.editedItem.descripcion || null,
      };

      const request = this.editedIndex === -1
        ? axios.post("/CatSensores/Crear", payload)
        : axios.put(`/CatSensores/Actualizar/${this.editedItem.idSensor}`, payload);

      request
        .then(() => {
          this.saving = false;
          this.close();
          this.initialize();
          this.showSnackbar(
            "Sensor guardado correctamente.",
            "success",
            "mdi-check-circle-outline"
          );
        })
        .catch((error) => {
          this.saving = false;
          this.handleError(error, "No se pudo guardar el sensor.");
        });
    },
    commitPendingAlias() {
      // El v-combobox no agrega el texto al modelo si el usuario no presiono Enter.
      // Aqui "volcamos" el texto pendiente para que no se pierda al guardar.
      const pending = (this.aliasSearch || "").trim();
      this.aliasSearch = "";
      if (!pending) return true;

      const yaExiste = (this.assignmentForm.aliases || []).some(
        (a) => this.normalizeAliasValue(a).toUpperCase() === pending.toUpperCase()
      );
      if (yaExiste) {
        this.assignmentErrors.aliases = `El alias "${pending}" ya existe.`;
        return false;
      }

      this.assignmentForm.aliases = [...(this.assignmentForm.aliases || []), pending];
      return true;
    },
    saveAssignment() {
      if (!this.assignmentTarget) return;
      if (!this.commitPendingAlias()) {
        this.showSnackbar(
          this.assignmentErrors.aliases || "Revisa los alias capturados.",
          "error",
          "mdi-alert-circle-outline"
        );
        return;
      }
      if (!this.validateAssignment()) {
        const msg =
          this.assignmentErrors.aliases ||
          this.assignmentErrors.idVariable ||
          this.assignmentErrors.general ||
          "Revisa los datos del formulario.";
        this.showSnackbar(msg, "error", "mdi-alert-circle-outline");
        return;
      }

      this.savingAssignment = true;
      const now = this.getCurrentIsoDateTime();
      const aliases = this.assignmentForm.aliases
        .map(this.normalizeAliasValue)
        .filter(Boolean);
      const sensorVariablePayload = {
        idSensor: this.assignmentTarget.idSensor,
        idVariable: this.assignmentForm.idVariable,
        fechaInicio: this.normalizeStartDateForBackend(this.assignmentForm.fechaInicio || now),
        fechaFin: null,
      };

      const sensorVariableRequest = this.assignmentForm.idSensorVariable
        ? this.requestSensorVariables(
          "put",
          `/Actualizar/${this.assignmentForm.idSensorVariable}`,
          sensorVariablePayload
        )
        : this.requestSensorVariables("post", "/Crear", sensorVariablePayload);

      sensorVariableRequest
        .then(() => this.loadSensorVariables(this.assignmentTarget.idSensor))
        .then(() => {
          const sensorVariable = this.assignmentForm.idSensorVariable
            ? this.sensorVariables.find(
              (item) => item.idSensorVariable == this.assignmentForm.idSensorVariable
            )
            : this.sensorVariables.find(
              (item) =>
                item.idSensor == this.assignmentTarget.idSensor &&
                item.idVariable == this.assignmentForm.idVariable
            );
          if (!sensorVariable || !sensorVariable.idSensorVariable) {
            throw new Error("No se pudo recuperar la relacion del sensor.");
          }

          const currentAliases = this.getAliasesForSensorVariable(sensorVariable.idSensorVariable);
          const syncPayload = {
            idSensorVariable: sensorVariable.idSensorVariable,
            aliases: aliases.map((alias) => {
              const existingAlias = currentAliases.find(
                (item) => this.normalizeAliasValue(item.clavePayload).toUpperCase() === alias.toUpperCase()
              );
              return existingAlias
                ? {
                  idAliasSensorVariable: existingAlias.idAliasSensorVariable,
                  clavePayload: alias,
                }
                : {
                  clavePayload: alias,
                };
            }),
          };

          return this.requestAliasSensorVariables("put", "/Sincronizar", syncPayload);
        })
        .then(() => Promise.all([
          this.loadSensorVariables(this.assignmentTarget.idSensor),
          this.loadAliasSensorVariables({ idSensor: this.assignmentTarget.idSensor }),
        ]))
        .then(() => {
          this.applyAssignmentsToSensores();
          this.savingAssignment = false;
          this.closeAssignmentDialog();
          this.showSnackbar(
            "Variable asignada correctamente.",
            "success",
            "mdi-check-circle-outline"
          );
        })
        .catch((error) => {
          this.savingAssignment = false;
          const message =
            error &&
            error.response &&
            error.response.data &&
            typeof error.response.data === "string"
              ? error.response.data
              : error &&
                error.response &&
                error.response.data &&
                error.response.data.msg
                ? error.response.data.msg
                : error && error.message
                  ? error.message
                  : "No se pudo guardar la asignacion.";
          if (typeof message === "string" && message.toLowerCase().indexOf("alias") >= 0) {
            this.assignmentErrors.aliases = message;
          } else {
            this.assignmentErrors.general = message;
          }
          console.log(error);
        });
    },
    deleteAssignment(item) {
      const idSensorVariable = item && item.idSensorVariable;
      if (!idSensorVariable) return;

      this.deletingAssignmentId = idSensorVariable;
      const sensorId = this.assignmentTarget ? this.assignmentTarget.idSensor : item.idSensor;
      const now = this.getCurrentIsoDateTime();
      const currentAliases = this.getAliasesForSensorVariable(idSensorVariable);

      Promise.resolve()
        .then(() => {
          const normalizeAliasRequests = currentAliases
            .filter((alias) => {
              const aliasDate = this.parseDateValue(alias.fechaInicio);
              const nowDate = this.parseDateValue(now);
              return aliasDate && nowDate && aliasDate > nowDate;
            })
            .map((alias) =>
              this.requestAliasSensorVariables(
                "put",
                `/Actualizar/${alias.idAliasSensorVariable}`,
                {
                  idSensorVariable,
                  clavePayload: alias.clavePayload,
                  fechaInicio: now,
                  fechaFin: null,
                }
              )
            );

          return Promise.all(normalizeAliasRequests);
        })
        .then(() => {
          const sensorVariableDate = this.parseDateValue(item.fechaInicio);
          const nowDate = this.parseDateValue(now);
          if (sensorVariableDate && nowDate && sensorVariableDate > nowDate) {
            return this.requestSensorVariables("put", `/Actualizar/${idSensorVariable}`, {
              idSensor: item.idSensor,
              idVariable: item.idVariable,
              fechaInicio: now,
              fechaFin: null,
            });
          }
          return null;
        })
        .then(() => this.requestAliasSensorVariables("put", "/Sincronizar", {
          idSensorVariable,
          aliases: [],
        }))
        .then(() => this.requestSensorVariables("put", `/Desactivar/${idSensorVariable}`))
        .then(() => Promise.all([
          this.loadSensorVariables(sensorId),
          this.loadAliasSensorVariables({ idSensor: sensorId }),
        ]))
        .then(() => {
          this.applyAssignmentsToSensores();
          this.deletingAssignmentId = null;
          this.showSnackbar(
            "Asignacion eliminada correctamente.",
            "success",
            "mdi-delete-circle-outline"
          );
        })
        .catch((error) => {
          this.deletingAssignmentId = null;
          this.handleError(error, "No se pudo eliminar la asignacion.");
        });
    },
    editItem(item) {
      this.editedIndex = this.sensores.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.errores = [];
      this.dialog = true;
    },
    toggleEstado(item) {
      const idSensor = item && item.idSensor;
      if (!idSensor) {
        this.showSnackbar(
          "No se encontro el identificador del sensor.",
          "error",
          "mdi-alert-circle-outline"
        );
        return;
      }

      const activar = item.condicion === false;

      if (!activar && item.variablesAsignadas > 0) {
        this.verAsociaciones(item);
        this.estadoNonce += 1;
        return;
      }

      this.togglingId = idSensor;
      axios
        .put(`/CatSensores/${activar ? "Activar" : "Desactivar"}/${idSensor}`)
        .then(() => {
          this.initialize();
          this.showSnackbar(
            activar ? "Sensor activado correctamente." : "Sensor desactivado correctamente.",
            "success",
            activar ? "mdi-check-circle-outline" : "mdi-delete-circle-outline"
          );
        })
        .catch((error) => {
          const status = error && error.response ? error.response.status : null;
          if (!activar && status === 409) {
            this.verAsociaciones(item);
          } else {
            this.handleError(
              error,
              activar ? "No se pudo activar el sensor." : "No se pudo desactivar el sensor."
            );
          }
          this.initialize();
        })
        .finally(() => {
          this.togglingId = null;
          this.estadoNonce += 1;
        });
    },
    verAsociaciones(item) {
      this.dependItem = item;
      this.dialogDependencias = true;
    },
    close() {
      this.dialog = false;
      this.errores = [];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    showSnackbar(text, color = "error", icon = "mdi-alert-circle-outline") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.icon = icon;
      this.snackbar.show = true;
    },
    handleError(error, fallbackMessage) {
      const message =
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
          ? error.response.data
          : fallbackMessage;

      if (this.dialog) {
        this.errores = [message];
      }
      if (this.dialogAssignment) {
        this.assignmentErrors.general = message;
      }
      this.showSnackbar(message, "error", "mdi-alert-circle-outline");
      console.log(error);
    },
  },
};
</script>

<style scoped>
.sensor-config-card {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  padding: 24px;
  background:
    radial-gradient(circle at top right, rgba(25, 118, 210, 0.14), transparent 28%),
    linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
  border: 1px solid rgba(25, 118, 210, 0.10);
}

.sensor-config-card--embedded {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}

.embedded-col {
  padding: 0;
}

.sensor-config-card__glow {
  position: absolute;
  inset: auto -60px -80px auto;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(25, 118, 210, 0.12), transparent 68%);
  pointer-events: none;
}

.sensor-config-card__header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.sensor-config-card__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 12px;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 6px;
}

.sensor-config-card__title {
  margin: 0;
  font-size: 30px;
  line-height: 1.05;
  color: #102a43;
}

.sensor-config-card__subtitle {
  margin: 8px 0 0;
  color: #5c6b7a;
  max-width: 560px;
}

.sensor-config-card__cta {
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(25, 118, 210, 0.22);
}

.sensor-config-card__toolbar {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.sensor-config-card__search {
  max-width: 380px;
}

.sensor-config-table {
  background: transparent;
}

.sensor-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
}

.sensor-name-cell__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 118, 210, 0.10);
}

.sensor-name-cell__title {
  font-weight: 700;
  color: #102a43;
}

.sensor-name-cell__caption {
  font-size: 12px;
  color: #7b8794;
}

.sensor-unit-chip {
  font-weight: 600;
}

.estado-switch {
  display: inline-flex;
  margin-top: 0;
  padding-top: 0;
}
.asoc-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.25;
  gap: 2px;
}
.asoc-cell__link {
  font-size: 12px;
  color: #1976d2;
  cursor: pointer;
}
.asoc-cell__link:hover {
  text-decoration: underline;
}
.depend-dialog__title {
  font-weight: 700;
  color: #b45309;
  word-break: normal;
}
.depend-dialog__list {
  margin: 0;
  padding-left: 18px;
}
.depend-dialog__list li {
  margin-bottom: 2px;
}

.sensor-empty-state {
  padding: 30px 16px;
  text-align: center;
}

.sensor-empty-state__title {
  margin-top: 10px;
  font-weight: 700;
  color: #334e68;
}

.sensor-empty-state__subtitle {
  margin-top: 4px;
  color: #7b8794;
}

.sensor-dialog {
  border-radius: 18px;
}

.sensor-dialog__title {
  color: #102a43;
  font-weight: 700;
}

.sensor-snackbar__content {
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 600;
}

@media (max-width: 960px) {
  .sensor-config-card {
    padding: 18px;
  }

  .sensor-config-card__header,
  .sensor-config-card__toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .sensor-config-card__search {
    max-width: none;
  }
}
</style>
